// Apply data-attributes for product-cards on home and collection pages
(() => {
  const path = window.location.pathname;
  if (path !== '/' && path !== '/home' && !path.includes('/collections/')) return;

  const applyAttrs = () => {
    if (document.body.hasAttribute('data-attrs-done')) return;
    
    document.querySelectorAll('form[data-instant-form-product-url]').forEach((card) => {
      const url = card.getAttribute('data-instant-form-product-url');
      const handle = url?.split('/products/')[1];
      const variantId = card.getAttribute('data-instant-form-variant-id');
      
      if (handle && variantId) {
        [card, card.querySelector('[data-instant-type="container"][data-abra-container]')].forEach(el => {
          if (el) {
            el.setAttribute('data-product-handle', handle);
            el.setAttribute('data-variant-id', variantId);
          }
        });
        
        card.querySelectorAll('[data-instant-dynamic-content-source="PRICE"], .iocQXuyrGqRQDhSrP-mO3xEDiPGSupAdkG').forEach(el => {
          el.setAttribute('data-product-handle', handle);
          el.setAttribute('data-variant-id', variantId);
        });
      }
    });

    document.body.setAttribute('data-attrs-done', 'true');
    window.Abra?.render?.();
  };

  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', applyAttrs) : applyAttrs();

  new MutationObserver((mutations) => {
    if (mutations.some(m => Array.from(m.addedNodes).some(n => n.matches?.('form[data-instant-form-product-url]')))) {
      document.body.removeAttribute('data-attrs-done');
      applyAttrs();
    }
  }).observe(document.body, { childList: true, subtree: true });
})();